import { useReduxState } from 'hooks';
import { ProfileAuthPassword, ProfileAuthTwoFactor } from '.';

const ProfileAuth = () => {
  const { user } = useReduxState();

  return (
    <div className="wrapper">
      <div>
        <ProfileAuthPassword />
      </div>

      {user?.passwordSet ? (
        <div style={{ marginTop: 20 }}>
          <ProfileAuthTwoFactor />
        </div>
      ) : null}
    </div>
  );
};

export default ProfileAuth;
